import React from 'react';

interface DataTableProps {
  data: Array<{
    [key: string]: string | number;
  }>;
  columns: Array<{
    key: string;
    label: string;
    width?: string;
    align?: 'left' | 'center' | 'right';
    render?: (value: any, row: any) => React.ReactNode;
  }>;
  title?: string;
  className?: string;
  maxHeight?: string;
}

const DataTable: React.FC<DataTableProps> = ({
  data,
  columns,
  title,
  className,
  maxHeight = '300px'
}) => {
  return (
    <div className={`bg-gray-900 rounded-lg p-4 ${className}`}>
      {title && (
        <div className="text-white text-sm font-medium mb-3">{title}</div>
      )}
      
      <div className="overflow-auto" style={{ maxHeight }}>
        <table className="w-full text-sm">
          <thead>
            <tr className="border-b border-gray-600">
              {columns.map((column) => (
                <th
                  key={column.key}
                  className={`py-2 px-3 text-gray-300 font-medium text-${column.align || 'left'}`}
                  style={{ width: column.width }}
                >
                  {column.label}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {data.map((row, index) => (
              <tr 
                key={index} 
                className="border-b border-gray-700 hover:bg-gray-800 transition-colors"
              >
                {columns.map((column) => (
                  <td
                    key={column.key}
                    className={`py-2 px-3 text-gray-200 text-${column.align || 'left'}`}
                  >
                    {column.render 
                      ? column.render(row[column.key], row)
                      : row[column.key]
                    }
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default DataTable;